export default __webpack_public_path__ + "static/brand_portal_keyart_bg-8f2e31ea8adb569eb8f75ce7ec02b5ed.jpg";